module.exports = __webpack_public_path__ + "img/unnamed5.938d159c.png";